{
  "title": "Cüzdan",
  "subtitle": "Bakiyeler yalnızca sunucudan okunur. Gerçek işlemler etkin değil.",
  "real": "Ana bakiye",
  "bonus": "Bonus",
  "reserved": "Rezerve",
  "unavailable": "Bakiye bilgisi kullanılamıyor",
  "deposit": "Yatır",
  "withdraw": "Çek",
  "history": "Geçmiş",
  "comingSoon": "Ödeme akışları yakında"
}
